{
  "title": "Resolver aeronave desconocida",
  "description": "Aeronaves que no pudieron emparejarse durante la importación de datos. Selecciona un tipo de aeronave para crear un tenant. Un administrador revisará y aprobará el mapeo FAA posteriormente.",
  "alerts": {
    "noActiveFBO": "No hay FBO activo seleccionado",
    "noPendingAircraft": "No hay aeronaves pendientes: ¡todas las aeronaves sincronizadas han sido emparejadas!"
  },
  "toolbar": {
    "refresh": "Actualizar",
    "pendingCount": "Pendientes"
  },
  "table": {
    "headers": {
      "tailNumber": "Matrícula",
      "typeHint": "Tipo de dato",
      "operator": "Operador",
      "mapToAircraft": "Asignar a aeronave",
      "created": "Creado"
    },
    "empty": "Sin aeronaves pendientes",
    "processing": "Creando organización...",
    "selectAircraft": "Seleccionar aeronave"
  },
  "messages": {
    "userNotAuthenticated": "Usuario no autenticado",
    "mappingFailed": "Error al asignar aeronave"
  },
  "fallbacks": {
    "unknownOperator": "Desconoc.",
    "unknownType": "Desconoc."
  }
}
